import script from "./ModernUsageGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./ModernUsageGrid.vue?vue&type=script&setup=true&lang=js"

import "./ModernUsageGrid.vue?vue&type=style&index=0&id=64700338&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64700338"]])

export default __exports__